// import { openReportViewerDialog } from '../store/reportViewDialogReducer';


function DynamicFieldsHeader(props) {
	return (
		<div className="flex flex-1 w-full items-center justify-between">
		</div>
	);
}

export default DynamicFieldsHeader;
